export enum JobStatuses {
  PENDING = 'PENDING_JOB_STATUS',
  SUCCESS = 'SUCCESS_JOB_STATUS',
  FAILURE = 'FAILURE_JOB_STATUS',
}
